export default class ListProposalRecordsError extends Error {
}
